module.exports = "<app-user-list\n  [role]=\"'ROLE_PARTICIPANT'\"\n>\n</app-user-list>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/user/participant/participant-list/participant-list.component.html
// module id = ../../../../../src/app/user/participant/participant-list/participant-list.component.html
// module chunks = main